import styled from "styled-components";
import { Form as SundayForm } from "sunday-component";
import { AutoCompleteErrorCss } from "./AutoCompleteForm";
import { CheckBoxErrorCss } from "./CheckBoxForm";
import { ChipGroupErrorCss } from "./ChipGroupForm";
import { DatePickerErrorCss } from "./DatePickerForm";
import { RadioGroupErrorCss } from "./RadioGroupForm";
import { TextAreaErrorCss } from "./TextAreaForm";
import { TextBoxErrorCss } from "./TextBoxForm";

const iceCreamErrorMessageStyle = `
  .sunday-component-form-item-explain-error {
    display: flex;
    align-items: center;
    gap: 4px;
    min-height: 24px;
    margin-top: 4px;
    color: var(--color-text-negative, #da3b45) !important;
    font-family: var(--typescale-font-th, "Noto Sans Thai"), sans-serif;
    font-size: var(--typescale-size-b-2, 15px);
    font-style: normal;
    font-weight: var(--typescale-weight-base-regular, 400);
    letter-spacing: var(--typescale-tracking-base, 0);
    line-height: var(--typescale-line-height-b-2, 24px);
    vertical-align: middle;
  }

  .sunday-component-form-item-explain-error::before {
    display: inline-flex;
    flex: 0 0 13.3px;
    align-items: center;
    justify-content: center;
    width: 13.3px;
    height: 13.3px;
    border-radius: 50%;
    background: var(--color-surface-negative, #da3b45);
    color: #ffffff;
    content: "!";
    font-size: 9px;
    font-weight: 700;
    line-height: 13.3px;
  }

  .sunday-component-form-item-explain-error:has(
      img[alt="consent-alert-icon"]
    )::before {
    display: none;
    content: none;
  }

  .sunday-component-form-item-explain-error > * {
    margin: 0 !important;
  }

  .sunday-component-form-item-explain-error > *,
  .sunday-component-form-item-explain-error > * * {
    color: inherit !important;
    font-family: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
  }

  .sunday-component-form-item-has-error {
    .sunday-component-radio-group-outline,
    .sunday-component-radio-group-outline .sunday-component-radio-wrapper,
    .ant-radio-button-wrapper,
    .sunday-component-select-selector {
      border-color: var(--color-stroke-negative, #da3b45) !important;
    }

    .sunday-component-radio-inner,
    .sunday-component-checkbox-inner {
      border-color: var(--color-stroke-negative, #da3b45) !important;
    }

    .icth-field-label {
      color: var(--color-text-negative, #da3b45) !important;
    }
  }
`;

const Form = styled(SundayForm)<{ $iceCream?: boolean }>`
  & {
    label {
      color: var(--ui-form-input-text-activated-label_text-color) !important;
    }
  }
  .sunday-component-form-item-with-help {
    label {
      color: var(--ui-form-input-text-error-label_text-color) !important;
    }
  }
  label.sunday-component-form-item-required::before {
    color: var(--ui-form-input-text-error-helper_text-color) !important;
  }
  .sunday-component-form-item-explain {
    color: var(--ui-form-input-text-error-helper_text-color) !important;
  }
  .sunday-component-form-item-has-error {
    ${TextBoxErrorCss}
    ${AutoCompleteErrorCss}
    ${DatePickerErrorCss}
    ${TextAreaErrorCss}
    ${ChipGroupErrorCss}
    ${RadioGroupErrorCss}
    ${CheckBoxErrorCss}
  }

  ${({ $iceCream }) => ($iceCream ? iceCreamErrorMessageStyle : "")}
`;

export default Form;
